import httpClient from './httpClient'

export default {
  Resource: {
    GetResourceTypes(payload) {
      return httpClient.post('/Resource/GetResourceTypes', payload)
    },
    GetResources(payload) {
      return httpClient.post('/Resource/GetResources', payload)
    },
    DeleteResource(payload) {
      return httpClient.post('/Resource/DeleteResource', payload)
    },
    IsResourceInUse(payload) {
      return httpClient.post('/Resource/IsResourceInUse', payload)
    },
    CreateResource(payload) {
      return httpClient.post('/Resource/CreateResource', payload, {
        timeout: 5 * 60 * 1000, // 5 minutes
      })
    },
    UpdateResource(payload) {
      return httpClient.post('/Resource/UpdateResource', payload, {
        timeout: 5 * 60 * 1000, // 5 minutes
      })
    },
  },
}
